import { Badge } from 'keep-react'
import { ResponseStatus } from 'api'

export const renderBadge = (status: ResponseStatus) => {
  let color: 'error' | 'success' | 'warning' | 'primary' | 'secondary' =
    'secondary'
  let label: string

  switch (status.toLocaleLowerCase()) {
    case 'cancelled':
      label = 'Anulada'
      color = 'error'
      break
    case 'declined':
      label = 'Não aceite'
      color = 'error'
      break
    case 'lapsed':
      label = 'Expirada'
      color = 'warning'
      break
    case 'lapsedqt':
      label = 'Expirada'
      color = 'warning'
      break
    case 'notpaid':
      label = 'Por liquidar'
      color = 'warning'
      break
    case 'active':
      label = 'Ativa'
      color = 'success'
      break
    case 'quoted':
      label = 'Em vigor'
      color = 'success'
      break
    default:
      label = status
      color = 'success'
      break
  }

  return (
    <Badge
      className="pointer-events-none whitespace-nowrap"
      color={color}
      variant="background"
    >
      {label}
    </Badge>
  )
}
